import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

export const Testimonials = () => (
  <section id="depoimentos" className="relative py-24 sm:py-32 bg-[#04120E]" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Quem já paga menos</Overline>
        <SectionTitle className="max-w-3xl">
          Clientes reais, <Accent>contas de luz menores</Accent>.
        </SectionTitle>
        <p className="mt-4 max-w-2xl text-sm sm:text-base text-emerald-100/55">
          Da conta de casa ao condomínio: veja quem já economiza com a Conexão Green.
        </p>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="group h-full rounded-2xl border border-white/10 bg-[#0B261E]/60 overflow-hidden transition-[border-color,transform] duration-300 hover:border-[#00E676]/45 hover:-translate-y-1.5"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={t.url}
                  alt={t.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B261E] to-transparent" />
                <span className="absolute bottom-3 left-4 rounded-full bg-[#00E676] text-[#04120E] text-xs font-bold px-3 py-1.5 shadow-lg">
                  {t.savings}
                </span>
              </div>
              <blockquote className="p-6">
                <Quote size={18} className="text-[#00E676]/60 mb-3" />
                <p className="text-sm text-emerald-100/75 leading-relaxed">“{t.quote}”</p>
                <figcaption className="mt-5">
                  <p className="font-heading font-bold text-white text-sm">{t.name}</p>
                  <p className="text-xs text-emerald-100/45 mt-0.5">{t.city}</p>
                </figcaption>
              </blockquote>
            </figure>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 text-[11px] text-emerald-100/40 max-w-3xl leading-relaxed">
        Depoimentos oficiais de clientes da iGreen Energy. Resultados individuais: o desconto vai até 15%, conforme a
        região, e o valor economizado depende do consumo.
      </p>
    </div>
  </section>
);
